// dedicated allowlist for CMS rich-text fields (e.g. preparationInstructions) -
// kept separate from any other sanitize configs so widening it doesn't affect other consumers
export const SANITIZE_RICH_TEXT_CONFIG = {
  allowedTags: [
    'p',
    'br',
    'ul',
    'ol',
    'li',
    'b',
    'strong',
    'i',
    'em',
    'u',
    'img',
    'video',
  ],
  allowedAttributes: {
    img: ['src', 'alt'],
    video: ['src', 'poster', 'controls'],
  },
  allowedSchemes: ['https'],
  disallowedTagsMode: 'discard' as const,
};
